import { API_URLS } from "@/utils/constant/api.constant";
import { C_API } from "../../utils/helper/api";

export const checkAuth = async () => {
  try {
    const response = await C_API.get(API_URLS.AUTH.CHECK);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const logout = async () => {
  try {
    const response = await C_API.get(API_URLS.SETTING.SECURITY.LOGOUT);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
